"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _AudiologistEmailFormViewStyle = _interopRequireDefault(require("../css/AudiologistEmailFormViewStyle"));

var _svgIcons = _interopRequireDefault(require("../css/svg-icons"));

var _pdfStyles = require("../css/pdf-styles");

var _reactRouterDom = require("react-router-dom");

var _utils = _interopRequireDefault(require("./utils"));

var _loader = _interopRequireDefault(require("./loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AudiologistEmailFormView = function AudiologistEmailFormView(_ref) {
  var viewData = _ref.viewData,
      pdfContent = _ref.pdfContent;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      inputsForm = _useState2[0],
      setInputsForm = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      emailSent = _useState4[0],
      setEmailSent = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setLoaderVisible = _useState6[1];

  var history = (0, _reactRouterDom.useHistory)();
  (0, _react.useEffect)(function () {
    prepareInputs();
    typeof dataLayer !== 'undefined' ? dataLayer.push({
      'event': 'vpv',
      'vpv': "".concat(window.location.href, "/send-to-your-audiologist/step6")
    }) : null;
  }, []);
  (0, _react.useEffect)(function () {
    if (emailSent) {
      history.push('/email-sent');
    }
  }, [emailSent]);

  var callBackFormFunction = function callBackFormFunction(status) {
    if (status.ok) {
      setLoaderVisible(false);
      setEmailSent(true);
    }
  };

  var isRequired = function isRequired(value) {
    return value.indexOf(_utils["default"].requiredCharacter) > -1;
  };

  var prepareInputs = function prepareInputs() {
    var newObject = {}; //extend array if you need to add new input

    var inputsArray = [viewData.audiologistEmailFormView.emailLabel.specificTag, viewData.audiologistEmailFormView.hcpEmail.specificTag, viewData.audiologistEmailFormView.nameLabel.specificTag];
    inputsArray.map(function (key) {
      newObject[key] = {
        required: isRequired(viewData.audiologistEmailFormView.emailPlaceholder.html.html),
        error: _utils["default"].validClass
      };
    });
    newObject.conditions = [];
    viewData.audiologistEmailFormView.conditions.map(function (condition) {
      if (condition) {
        newObject.conditions.push({
          required: isRequired(condition.html.html),
          error: _utils["default"].validClass,
          checked: false
        });
      }
    });
    setInputsForm(newObject);
  };

  var emailValidation = function emailValidation(value) {
    var re = _utils["default"].emailValidation;
    return re.test(String(value).toLowerCase());
  };

  var formValidation = function formValidation() {
    var inputsValues = _objectSpread({}, inputsForm);

    inputsValues.isValid = true;
    Object.keys(inputsValues).map(function (element) {
      var input = inputsValues[element];

      if (input.required) {
        if (element.toLowerCase().indexOf('email') > -1) {
          inputsValues[element].error = emailValidation(input.value) ? _utils["default"].validClass : _utils["default"].invalidClass;
        } else {
          inputsValues[element].error = input.value ? _utils["default"].validClass : _utils["default"].invalidClass;
        }

        inputsValues[element].error === _utils["default"].invalidClass ? inputsValues.isValid = false : null;
      }
    });
    inputsValues.conditions.map(function (checkbox) {
      if (!checkbox.checked) {
        checkbox.error = _utils["default"].invalidClass;
        inputsValues.isValid = false;
      }
    });
    setInputsForm(inputsValues);
    return inputsValues.isValid;
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();

    if (formValidation()) {
      sendEmail();
    }
  };

  var sendEmail = function sendEmail() {
    setLoaderVisible(true);
    var settings = {
      defaultTemplateSettings: {
        MailTemplatePath: "/Preparation tool/EmailTemplate",
        htmlTemplatePath: "/sitecore/content/Oticon/main/Settings/Mail Templates/Preparation tool/preparation-tool",
        emailBodyContent: "",
        logoElement: "<div class=\"pdf-logo\" style=\"background-image: url('".concat(document.querySelector('.logo-svg-oticon img').src, "');\"></div>"),
        customStyle: String(_pdfStyles.pdfStylesWithImage),
        pdfContent: pdfContent ? String(pdfContent) : '<p style="text-align: center;"><strong>Something went wrong</strong></p>',
        emailSender: inputsForm.emailLabel.value,
        hcpEmail: inputsForm.hcpEmail.value,
        EmailReceiver: inputsForm.hcpEmail.value,
        pdfName: viewData.features.pdfName ? String(viewData.features.pdfName.html.html.trim()) + '.pdf' : 'preparation_visit.pdf',
        name: inputsForm.nameLabel.value,
        languageCode: 'en',
        //additional params which you want to send to webservice
        additionalParams: {// Password: 'asd'
        }
      }
    };
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@demant/feature-pdf-creator'));
    }).then(function (result) {
      return result["default"];
    }).then(function (pdfCreator) {
      pdfCreator(settings, 'send', callBackFormFunction);
    });
  };

  var handleChangeInput = function handleChangeInput(e) {
    var inputsValues = _objectSpread({}, inputsForm);

    inputsValues[e.currentTarget.id].value = e.currentTarget.value;
    inputsValues[e.currentTarget.id].error = e.currentTarget.value ? _utils["default"].validClass : _utils["default"].invalidClass;
    setInputsForm(inputsValues);
  };

  var handleChangeCheckbox = function handleChangeCheckbox(e, index) {
    var inputsValues = _objectSpread({}, inputsForm);

    inputsValues.conditions[index].checked = e.currentTarget.checked;
    inputsValues.conditions[index].error = e.currentTarget.checked ? _utils["default"].validClass : _utils["default"].invalidClass;
    setInputsForm(inputsValues);
  };

  return /*#__PURE__*/_react["default"].createElement(_AudiologistEmailFormViewStyle["default"], null, Object.keys(inputsForm).length && viewData && /*#__PURE__*/_react["default"].createElement("form", {
    className: "hcp-email",
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    }
  }, viewData.audiologistEmailFormView && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hcp-email-header",
    dangerouslySetInnerHTML: {
      __html: viewData.audiologistEmailFormView.emailSendHeadline.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hcp-email-form"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "close-button",
    to: "review-answers"
  }, "x"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "close-button",
    onClick: function onClick() {
      return history.push('/review-answers');
    }
  }, "x"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "email-icon",
    dangerouslySetInnerHTML: {
      __html: _svgIcons["default"].email
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper ".concat(inputsForm[viewData.audiologistEmailFormView.hcpEmail.specificTag].error)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: viewData.audiologistEmailFormView.hcpEmail.specificTag
  }, viewData.audiologistEmailFormView.hcpEmail.html.html), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    id: viewData.audiologistEmailFormView.hcpEmail.specificTag,
    placeholder: viewData.audiologistEmailFormView.hcpPlaceholder.html.html.trim(),
    name: "emailhcp",
    onChange: handleChangeInput
  }), inputsForm[viewData.audiologistEmailFormView.hcpEmail.specificTag].error === _utils["default"].invalidClass && /*#__PURE__*/_react["default"].createElement("span", {
    className: "validation-message"
  }, viewData.features.validationMessage.html.html)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper ".concat(inputsForm[viewData.audiologistEmailFormView.nameLabel.specificTag].error, " ").concat(viewData.audiologistEmailFormView.nameLabel.specificTag, " ").concat(viewData.audiologistEmailFormView.nameLabel.specificTag)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: viewData.audiologistEmailFormView.nameLabel.specificTag
  }, viewData.audiologistEmailFormView.nameLabel.html.html), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    id: viewData.audiologistEmailFormView.nameLabel.specificTag,
    placeholder: viewData.audiologistEmailFormView.namePlaceholder.html.html.trim(),
    name: "name",
    onChange: handleChangeInput
  }), inputsForm[viewData.audiologistEmailFormView.nameLabel.specificTag].error === _utils["default"].invalidClass && /*#__PURE__*/_react["default"].createElement("span", {
    className: "validation-message"
  }, viewData.features.validationMessage.html.html)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper ".concat(inputsForm[viewData.audiologistEmailFormView.emailLabel.specificTag].error)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: viewData.audiologistEmailFormView.emailLabel.specificTag
  }, viewData.audiologistEmailFormView.emailLabel.html.html.trim()), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    id: viewData.audiologistEmailFormView.emailLabel.specificTag,
    placeholder: viewData.audiologistEmailFormView.emailPlaceholder.html.html.trim(),
    name: "email",
    onChange: handleChangeInput
  }), inputsForm[viewData.audiologistEmailFormView.emailLabel.specificTag].error === _utils["default"].invalidClass && /*#__PURE__*/_react["default"].createElement("span", {
    className: "validation-message"
  }, viewData.features.validationMessage.html.html)), viewData.audiologistEmailFormView.conditions && viewData.audiologistEmailFormView.conditions.map(function (condition, index) {
    return condition ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "condition-wrapper ".concat(inputsForm.conditions[index].error),
      key: index
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      id: condition.specificTag,
      onChange: function onChange(e) {
        return handleChangeCheckbox(e, index);
      }
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: condition.specificTag
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "custom-checkbox"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: condition.html.html
      }
    })), inputsForm.conditions[index].error === _utils["default"].invalidClass && /*#__PURE__*/_react["default"].createElement("span", {
      className: "validation-message"
    }, viewData.features.validationMessage.html.html)) : '';
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "submit",
    className: "button",
    onClick: handleSubmit
  }, viewData.buttons.sendButton.html.html.trim())), isLoading && /*#__PURE__*/_react["default"].createElement(_loader["default"], null))));
};

var _default = AudiologistEmailFormView;
exports["default"] = _default;